import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import * as i1 from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';

class XpoSsi {
    set name(value) {
        this.nameValue = value;
    }
    get name() {
        return this.statusValue ? `${this.nameValue}_${this.statusValue}` : this.nameValue;
    }
    set status(value) {
        this.statusValue = value;
    }
}
XpoSsi.ɵfac = function XpoSsi_Factory(t) { return new (t || XpoSsi)(); };
XpoSsi.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoSsi, selectors: [["xpo-ssi"]], hostAttrs: [1, "xpo-Ssi"], inputs: { name: "name", status: "status" }, decls: 1, vars: 1, consts: [[3, "iconName"]], template: function XpoSsi_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "xpo-icon", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("iconName", ctx.name);
    } }, directives: [i1.XpoIcon], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSsi, [{
        type: Component,
        args: [{
                selector: 'xpo-ssi',
                templateUrl: './special-service-indicator.component.html',
                host: { class: 'xpo-Ssi' },
            }]
    }], null, { name: [{
            type: Input
        }], status: [{
            type: Input
        }] }); })();

class XpoSsiModule {
}
XpoSsiModule.ɵfac = function XpoSsiModule_Factory(t) { return new (t || XpoSsiModule)(); };
XpoSsiModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoSsiModule });
XpoSsiModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatIconModule,
            XpoIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSsiModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoSsi],
                imports: [
                    CommonModule,
                    MatIconModule,
                    XpoIconModule,
                ],
                exports: [XpoSsi]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoSsiModule, { declarations: [XpoSsi], imports: [CommonModule,
        MatIconModule,
        XpoIconModule], exports: [XpoSsi] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoSsi, XpoSsiModule };
